import { Typography, Box, CircularProgress } from "@mui/material";

import Tabs from "../../components/Tabs";

import { WebSettingsTab } from "../../components/settings/tabs/WebSettingsTab";
import { CustomLogoTab } from "../../components/settings/tabs/CustomLogoTab";

import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { useSettingsContext } from "../../context/SettingsContext";
import { hasCustomBrandingAccess } from "../../utils/user-utils";

const Settings = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const {
    isFetching,
    classes,
    selectedTab,
    user,
    handleSettingsTabChange,
    setIsDeleteModalOpen,
  } = useSettingsContext();

  if (isFetching) {
    return (
      <Box style={{ flex: 1 }}>
        <Box className={classes.loadingContainer}>
          <CircularProgress style={{ color: theme.palette.main.primary.o }} />
        </Box>
      </Box>
    );
  }

  const tabs = [
    {
      value: "web_settings",
      label: t("settingsTabs.webSettings"),
      content: <WebSettingsTab />,
      visible: user?.registeredFrom === "internal",
    },
    {
      value: "custom_branding",
      label: t("settingsTabs.customLogo"),
      content: <CustomLogoTab />,
      visible: hasCustomBrandingAccess(user),
    },
  ];

  return (
    <Box style={{ flex: 1 }}>
      <Tabs
        onTabChange={handleSettingsTabChange}
        selectedTab={selectedTab}
        tabs={tabs}
        endContent={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              className={classes.redText}
              onClick={() => setIsDeleteModalOpen(true)}
            >
              {t("deleteWebsite")}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
};

export default Settings;
